import React from 'react';
import { TextLink } from '../../text-link/index.js';
export const RichtextTextLink = ({ children, ...props }) => (React.createElement(TextLink, { ...props, variant: "inline", size: "md", icon: "external-link" }, children));
//# sourceMappingURL=text-link.js.map